import _ from 'lodash';
import moment from 'moment-timezone';
import { apiSearch, apiFetch } from '../modules/utility';

const apiBase = 'ticket';
const idField = `${apiBase}Id`;
const idsField = `${idField}s`;
const item = 'ticket';
const onSuccessRedirectTo = `/ticket/list`;

const MY_TICKETS_RESULT = 'myTickets/SEARCH';
const NEW_MY_TICKET = 'myTickets/NEW';

const TICKET_SEARCH_RESULT = 'ticket/SEARCH';
const TICKET_STATUS_CHANGE = 'ticket/CHANGE';

const initialState = {
	myTicketIds: undefined,
	byStatus: {},
};

const reducers = (state = initialState, action) => {
	if (action.type === MY_TICKETS_RESULT) {
		return {
			...state,
			myTicketIds: _.map(action.tickets, 'ticketId'),
		};
	} else if (action.type === NEW_MY_TICKET) {
		const { ticketId } = action.ticketId;

		const myTicketIds = _.get(state, ['myTicketIds']);
		if (!myTicketIds) {
			return state;
		}

		const newMyTicketIds = _.uniq(myTicketIds.concat([ticketId]));
		return {
			...state,
			myTicketIds: newMyTicketIds,
		};
	} else if (action.type === TICKET_SEARCH_RESULT) {
		if (action.status) {
			return {
				...state,
				byStatus: {
					...state.byStatus,
					[action.status]: _.map(action.tickets, 'ticketId'),
				},
			};
		} else {
			return state;
		}
	} else if (action.type === TICKET_STATUS_CHANGE) {
		const { status, ticketId } = action.ticket;

		const openIds = _.get(state, ['byStatus', 'open']);
		const closedIds = _.get(state, ['byStatus', 'closed']);

		if (!openIds || !closedIds) {
			return state;
		}

		if (status === 'complete') {
			const newClosedIds = _.uniq(closedIds.concat([ticketId]));
			const newOpenIds = _.filter(openIds, (id) => {
				return id !== ticketId;
			});

			return {
				...state,
				byStatus: {
					...state.byStatus,
					open: newOpenIds,
					closed: newClosedIds,
				},
			};
		} else {
			const newOpenIds = _.uniq(openIds.concat([ticketId]));
			return {
				...state,
				byStatus: {
					...state.byStatus,
					open: newOpenIds,
				},
			};
		}
	} else {
		return state;
	}
};
export default reducers;

export const searchMyTickets = (p) => {
	const { assignedToUserId, callback = _.noop } = p;

	return (dispatch) => {
		const params = {
			assignedToUserIds: [assignedToUserId],
			afterDate: moment().subtract(4, 'months').format('YYYY-MM-DD'),
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}

				const tickets = _.get(r, ['collections', 'ticketCollection']);

				dispatch({
					type: MY_TICKETS_RESULT,
					assignedToUserId,
					tickets,
				});
				callback();
			},
		});
	};
};

export const search = (p) => {
	const {
		isBilling,
		status,
		assignedToUserIds,
		notAssignedToUserIds,
		afterDate,
		callback = _.noop,
	} = p;

	return (dispatch) => {
		const params = {
			status,
			afterDate,
			assignedToUserIds,
			notAssignedToUserIds,
		};

		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}

				const tickets = _.get(r, ['collections', 'ticketCollection']);
				dispatch({
					type: TICKET_SEARCH_RESULT,
					status: isBilling ? 'billing' : status,
					tickets,
				});
				callback();
			},
		});
	};
};

/*
export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};
*/

export const advancedSearch = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.advancedSearch`,
			params,
			dispatch,
			callback,
		});
	};
};

export const get = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getEmailInfo = ({ params = {}, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getEmailInfo`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			listNameToUpdate: idsField,
			savingMessage: `Adding new ${item}...`,
			savedMessage: `New ${item} was created successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay: 350,
			callback,
		});
	};
};

/*
export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage : `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			delay:350,
			callback,
		});
	};
}
 */

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			savingMessage: `Updating ${item}...`,
			savedMessage: `${_.capitalize(item)} updated successfully. 
				Click continue to return to the ${item}s page.`,
			onSuccessRedirectTo,
			callback: (err, r) => {
				if (err) {
					return callback(err);
				}
				const ticket = _.get(r, ['collections', 'ticketCollection', 0]);
				dispatch({
					type: TICKET_STATUS_CHANGE,
					ticket,
				});
				callback();
			},
		});
	};
};

export const getChangeLogs = ({ ticketId, callback = _.noop }) => {
	return (dispatch) => {
		apiSearch({
			method: `${apiBase}.getChangeLogs`,
			base: 'ticketChangeLog',
			keyBy: ticketId,
			params: {
				ticketId,
			},
			dispatch,
			callback,
		});
	};
};
